import { z } from 'zod'

import type { ZodSimplify } from '@mntn-dev/utility-types'
import {
  CustomerOrganizationTypeSchema,
  OrganizationDomainInsertModelSchema,
} from './organization.models.ts'
import { UserDomainInsertModelSchema } from './user.models.ts'

export const OrganizationRegistrationModelSchema =
  OrganizationDomainInsertModelSchema.pick({
    name: true,
    websiteUrl: true,
  }).extend({
    organizationType: CustomerOrganizationTypeSchema,
  })

export const UserRegistrationModelSchema = UserDomainInsertModelSchema.pick({
  firstName: true,
  lastName: true,
  emailAddress: true,
})

export const RegistrationModelSchema = z.object({
  user: UserRegistrationModelSchema,
  organization: OrganizationRegistrationModelSchema,
})

export type AccountRegistrationModel = ZodSimplify<
  typeof RegistrationModelSchema
>
